import React from 'react';

type FormatButtonProps = {
  active?: boolean;
  onClick: () => void;
  children: React.ReactNode;
  title: string;
};

export const FormatButton: React.FC<FormatButtonProps> = ({ active, onClick, children, title }) => (
  <button
    className={`w-6 h-6 flex items-center justify-center rounded hover:bg-gray-500/10 dark:hover:bg-gray-700/50 transition-colors ${
      active ? 'text-blue-500 dark:text-blue-400' : 'text-gray-600 dark:text-gray-400'
    }`}
    onMouseDown={(e) => {
      e.preventDefault();
      onClick();
    }}
    title={title}
    type="button">
    {children}
  </button>
);
